import styled from "@emotion/styled";

const RankNumber = styled("span")(({ theme, hasTwoDigits }) => ({
  color: "black",
  fontFamily: "Red Hat Text",
  fontSize: 64,
  fontWeight: 700,
  background: "-webkit-linear-gradient(#3882FF, #47D4D7)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  marginRight: hasTwoDigits ? -20 : -10,
  [theme.breakpoints.up("mobile")]: {
    marginRight: hasTwoDigits ? -45 : -15,
    fontSize: 135,
  },
}));

export default RankNumber;
